// src/sections/Hero.jsx

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { hero, siteMeta } from "../data/siteContent";
import { fadeUp, staggerParent, slideLeft, slideRight } from "../utils/motion";
import PrimaryButton from "../components/ui/PrimaryButton";
import Pill from "../components/ui/Pill";

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });

  const mediaY = useTransform(scrollYProgress, [0, 1], [0, -120]);
  const mediaScale = useTransform(scrollYProgress, [0, 1], [1, 0.92]);
  const textY = useTransform(scrollYProgress, [0, 1], [0, -40]);

  return (
    <section className="hero-section" id="hero" ref={ref}>
      {/* <div className="hero-section__bg-grid" /> */}
      <div className="hero-section__glow hero-section__glow--one" />
      <div className="hero-section__glow hero-section__glow--two" />

      <div className="container-shell hero-layout">
        <motion.div
          className="hero-copy"
          style={{ y: textY }}
          variants={staggerParent}
          initial="hidden"
          animate="show"
        >
          <motion.div className="section-eyebrow" variants={fadeUp}>
            {hero.eyebrow}
          </motion.div>

          <motion.h1 variants={slideLeft}>{hero.title}</motion.h1>
          <motion.p className="hero-copy__text" variants={fadeUp}>
            {hero.subtitle}
          </motion.p>

          <motion.div className="hero-copy__actions" variants={fadeUp}>
            <PrimaryButton href={siteMeta.ctaHref} target="_blank">
              {siteMeta.ctaLabel}
            </PrimaryButton>
            <a href="#model" className="btn btn--ghost">
              Explore Model
            </a>
          </motion.div>

          <div className=" hero-stats">
            {hero.stats.map((item) => (
              <motion.div
                key={item.label}
                className="hero-stat-card"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.65 }}
              >
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="hero-media-wrap"
          style={{ y: mediaY, scale: mediaScale }}
          variants={slideRight}
          initial="hidden"
          animate="show"
        >
          <img
            src={siteMeta.hero1}
            alt="Dryvziro logo"
            className="hero-logo-object"
          />
        </motion.div>
      </div>
      <motion.div
        className="container-shell hero-copy__trust"
        variants={fadeUp}
      >
        {hero.trust.map((item) => (
          <Pill key={item}>{item}</Pill>
        ))}
      </motion.div>
    </section>
  );
}
